namespace Nobox
{
    @Serenity.Decorators.registerFormatter()
    export class AutoNumericFormatter implements Slick.Formatter {
        format(ctx: Slick.FormatterContext) {
            var input = $(`<input type="text">`);

            var optionAuto = $.cookie("formatnumber");
            if (optionAuto == null) {
                input.autoNumeric('init');
            } else {
                var formatnumber = JSON.parse(decodeURIComponent(optionAuto));
                if (jQuery.isEmptyObject(formatnumber)) {
                } else {
                    var obj = {};
                    if ('aDec' in formatnumber) {
                        obj["aDec"] = formatnumber["aDec"];
                    }
                    if ('mDec' in formatnumber) {
                        obj["mDec"] = formatnumber["mDec"];
                    }
                    if ('aSep' in formatnumber) {
                        obj["aSep"] = formatnumber["aSep"];
                    }
                    if ('dGroup' in formatnumber) {
                        obj["dGroup"] = formatnumber["dGroup"];
                    }
                    if ('lZero' in formatnumber) {
                        obj["lZero"] = formatnumber["lZero"];
                    }
                    input.autoNumeric('init', obj);
                }
            }
            if (ctx.value == "" || ctx.value == null) {
                return "";
            } else {
                input.autoNumeric('set', ctx.value);
                return input.val();
            }
        }
    }
}
